export class frmPeticion {
  "idCaracter": number = null;
  "caracter": string = "";
  "idPartido": number = null;
  "partido": string = "";
  "peticionario": string = "";
  "narracion": string = "";
  "afectacion": string = "";
  "procedimientoSancionador": string = "";
  "hechosDenunciados": string = "";
  "keyFile": File = null;
  "keyFileName": string = "";
  "anexo": File = null;
  "anexos": File[] = [];
  "anexoName": string = "";
}

export class frmUbicacion {
  "idMunicipio": number = null;
  "idOrgano": number = null;
  "colonia": string = "";
  "cp": string = "";
  "calle": string = "";
  "referencia": string = "";
  "url": string = "";
  "fechaPublicacion": string = "";
  "latitud": number = null;
  "longitud": number = null;
}

export class frmDesechar {
  "improcedencia": number = null;
  "descripcion": string = "";
  "anexo": File = null
  "anexoName": string = "";
}

export class frmCancelar {
  "describe": string = "";
  "key": File = null;
  "keyName": string = "";
}

export class frmDiligencia {
  "diligenciaFechaInicio": string = "";
  "diligenciaHoraInicio": string = "";
  "diligenciaFechaFinal": string = "";
  "diligenciaHoraFinal": string = "";
  "actaFechaInicio": string = "";
  "actaHoraInicio": string = "";
  "actaFechaFinal": string = "";
  "actaHoraFinal": string = "";
  "actaFolios": string = "";
  "copiaFechaEntrega": string = "";
  "copiaFile": File = null;
  "copiaFileName": string = "";
  "copiaNombrePeticionario": string = "";
  "copiaNoCopia": number = null;
}

export class frmReasignar {
  "idOrgano": number = null;
}

export class frmAdmicionParcial {
  "descripcion": string = "";
  "adjunto": File = null;
  "adjuntoName": string = "";
}

export class frmCopia {
  "idSolicitud": number = null;
  "acta": File = null;
}

export class frmRequerir {
  "adjuntoRequerir": File = null;
  "adjuntoRequerirName": string = "";
}

export class frmResponder {
  "adjuntoResponder": File = null;
  "adjuntoResponderName": string = "";
  "key": File = null;
  "keyName": string = "";
  "respuestaFecha": string = "";
  "respuestaHora": string = "";
}

export class frmActa {
  "acta": File = null;
  "actaName": string = "";
}

export class frmReporte {
  "fechaInicio": string = "";
  "fechaFin": string = "";
}
